import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'
import {
  orderCaptureFormForCardReducer, orderCaptureFilterReducer,
  orderCapturesDataReducer, userDetailsReducer
} from './models/orderCaptures'

export default (store) => ({
  path: 'order-capture',
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const OrderCaptureDetails = require('./containers/OrderCaptures').default
      // /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'orderCaptureFilter', reducer: orderCaptureFilterReducer})
      injectReducer(store, {key: 'orderCaptureFormForCard', reducer: orderCaptureFormForCardReducer})
      injectReducer(store, {key: 'orderCaptureData', reducer: orderCapturesDataReducer})
      injectReducer(store, {key: 'userDetails', reducer: userDetailsReducer})

      /*  Return getComponent   */
      cb(null, OrderCaptureDetails)

      /* Webpack named bundle   */
    }, 'orderCapture')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OrderCapture/index.js